export function getResponseStatus (obj) {
  if (typeof obj !== 'object' || obj === null) {
    return undefined
  }

  if (obj.hasOwnProperty('status')) {
    return obj.status
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const result = getResponseStatus(obj[key])
      if (result !== undefined) {
        return result
      }
    }
  }
  return undefined
}
